import { render, staticRenderFns } from "./AddressMutationPage.vue?vue&type=template&id=35246bb3&scoped=true"
import script from "./AddressMutationPage.vue?vue&type=script&lang=js"
export * from "./AddressMutationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35246bb3",
  null
  
)

export default component.exports